// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2fSkD","rightAdornment":"Header_rightAdornment__3Og7H"};